import { defineMessages } from 'react-intl';

export default defineMessages({
    noCoverage: {
        id: 'platform-quoteandbind.bop.directives.bop-building-directive.No Coverages',
        defaultMessage: 'No Coverages',
    },
    noneSelected: {
        id: 'platform-policycommon.directives.coverages.select.None Selected',
        defaultMessage: 'None Selected',
    },
    selectedValue: {
        id: 'platform-policycommon.The value must be between',
        defaultMessage: 'The value must be between {minValue} and {maxValue}',
    },
    noLesssThan: {
        id: 'platform-policycommon.Must be no less than',
        defaultMessage: "Must be no less than {minValue}"
    },
    noGreaterThan: {
        id: 'platform-policycommon.Must be no greater than',
        defaultMessage: "Must be no greater than {maxValue}"
    },
    miniValue: {
        id: 'platform-policycommon.The minimum allowed value is',
        defaultMessage: 'The minimum allowed value is {minValue}',
    },
    maxiValue: {
        id: 'platform-policycommon.The maximum allowed value is',
        defaultMessage: 'The maximum allowed value is {maxValue}',
    },
    minValue: {
        id: 'policycommon.Minimum value is',
        defaultMessage: 'Minimum value is {minValue}',
    },
    maxValue: {
        id: 'policycommon.Maximum value is',
        defaultMessage: 'Maximum value is {maxValue}',
    },
    updatingSelection: {
        id: 'platform-policycommon.directives.coverages.Updating selection...',
        defaultMessage: 'Updating selection...',
    },
    multipleOf: {
        id: 'platform-twia.policycommon.directives.coverages.multipleOf',
        defaultMessage: 'Limits must be entered in increments of {multipleValue}.',
    },
    multipleOfTfpa: { // DE16380
        id: 'platform-twia.policycommon.directives.coverages.multipleOfTfpa',
        defaultMessage: 'Property Limit must be increments of $100',
    },
    minMaxStuctureLimit: {
        id: 'platform-policycommon.The Structure Limit cannot be less than',
        defaultMessage: 'The Structure Limit cannot be less than {minValue} or more than {maxValue}',
    },
    minMaxPropertyLimit: {
        id: 'platform-policycommon.The Personal Property Limit cannot be less than',
        defaultMessage: 'The Personal Property Limit cannot be less than {minValue} or more than {maxValue}',
    },
});
